import { render, staticRenderFns } from "./tooltip-type-of-issue.vue?vue&type=template&id=58b7df40&scoped=true&"
import script from "./tooltip-type-of-issue.vue?vue&type=script&lang=js&"
export * from "./tooltip-type-of-issue.vue?vue&type=script&lang=js&"
import style0 from "./tooltip-type-of-issue.vue?vue&type=style&index=0&id=58b7df40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b7df40",
  null
  
)

export default component.exports